/* tslint:disable */
/* eslint-disable */
/**
 * Leads API
 * API for managing leads (potential customers from external sources)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Option souscrite dans la simulation
 * @export
 * @interface SimulationOptionDto
 */
export interface SimulationOptionDto {
    /**
     * Code de l'option
     * @type {string}
     * @memberof SimulationOptionDto
     */
    code?: string;
    /**
     * Libellé de l'option
     * @type {string}
     * @memberof SimulationOptionDto
     */
    label?: string;
    /**
     * Indique si l'option est incluse
     * @type {boolean}
     * @memberof SimulationOptionDto
     */
    included?: boolean;
    /**
     * Surprime mensuelle pour cette option
     * @type {number}
     * @memberof SimulationOptionDto
     */
    additionalPremium?: number | null;
}

/**
 * Check if a given object implements the SimulationOptionDto interface.
 */
export function instanceOfSimulationOptionDto(value: object): value is SimulationOptionDto {
    return true;
}

export function SimulationOptionDtoFromJSON(json: any): SimulationOptionDto {
    return SimulationOptionDtoFromJSONTyped(json, false);
}

export function SimulationOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulationOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'label': json['label'] == null ? undefined : json['label'],
        'included': json['included'] == null ? undefined : json['included'],
        'additionalPremium': json['additionalPremium'] == null ? undefined : json['additionalPremium'],
    };
}

export function SimulationOptionDtoToJSON(json: any): SimulationOptionDto {
    return SimulationOptionDtoToJSONTyped(json, false);
}

export function SimulationOptionDtoToJSONTyped(value?: SimulationOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'label': value['label'],
        'included': value['included'],
        'additionalPremium': value['additionalPremium'],
    };
}

